import { render, staticRenderFns } from "./ModalExamUpload.vue?vue&type=template&id=250408cf&scoped=true"
import script from "./ModalExamUpload.vue?vue&type=script&lang=js"
export * from "./ModalExamUpload.vue?vue&type=script&lang=js"
import style0 from "./ModalExamUpload.vue?vue&type=style&index=0&id=250408cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250408cf",
  null
  
)

export default component.exports